import { formatNumber } from "accounting"
import { Dropdown, Flex, Space, Tag, Tooltip, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import ButtonComponent from "../../../../../Components/Button"
import { titleSortFilters } from "../../../../../Components/titleSortFilters"
import Icon from "../../../../../Icon"
import {
  alertsColumnIconMap,
  dateFormat,
  excludeOption,
  serviceMap,
  statusMap,
  statusTextMap,
  tagMap
} from "../../../../../Utils/utils"

dayjs.extend(utc)

const previouslyConnectedEnrollmentsMap = {
  ethoca: "Ethoca",
  cdrn: "CDRN",
  rdr: "RDR",
  "i’m not sure": "I’m not sure"
}

const { Paragraph, Text, Link } = Typography

export const getColumns = ({ options, handleChangeStatus, onSelectRow }) => ({
  status: {
    key: "request_status",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Status",
        sorter: true,
        icon: alertsColumnIconMap["status"],
        stateData: state,
        key: "request_status"
      }),
    dataIndex: "request_status",
    fixed: "left",
    minWidth: 110,
    render: (_, record) => {
      return (
        <Dropdown
          destroyPopupOnHide={true}
          overlayClassName="custom-dropdown"
          menu={{
            items: options?.map((el) => {
              const isRdr = record?.enrollments === "rdr"
              if (el !== _ && (!isRdr ? !excludeOption.includes(el) : true))
                return {
                  key: el,
                  label: (
                    <Flex gap={8} align="center">
                      <Text>{statusTextMap[el] || el}</Text>
                    </Flex>
                  )
                }
            }),
            onClick: ({ key }) => handleChangeStatus({ id: record.id, newStatus: key })
          }}
        >
          <Tag
            color={statusMap[_] || tagMap[_?.toLowerCase()] || "default"}
            key={_}
            className={`simple newTagStyle ${statusMap[_]}`}
            style={{ margin: 0 }}
          >
            <Flex gap={8} align="center">
              <Text>{statusTextMap[_] || _}</Text>
              <Icon type="chevron_down_small" style={{ marginLeft: -4, marginRight: -4 }} />
            </Flex>
          </Tag>
        </Dropdown>
      )
    }
  },
  user_full_name: {
    key: "user_full_name",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "User full name",
        sorter: true,
        icon: alertsColumnIconMap["user_full_name"],
        stateData: state,
        key: "user_full_name"
      }),
    dataIndex: "user_full_name",
    minWidth: 185,
    render: (_) => (_ ? <Text>{_}</Text> : "—")
  },
  user_email: {
    key: "user_email",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "User email",
        sorter: true,
        icon: alertsColumnIconMap["user_email"],
        stateData: state,
        key: "user_email"
      }),
    dataIndex: "user_email",
    minWidth: 185,
    render: (_) => (_ ? <Text>{_}</Text> : "—")
  },
  merchant_descriptor: {
    key: "merchant_descriptor",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "Billing descriptor",
        //sorter: true,
        icon: alertsColumnIconMap["merchant_descriptor"],
        stateData: state,
        key: "merchant_descriptor"
      }),
    dataIndex: "merchant_descriptor",
    minWidth: 185,
    //render: (_) => _?.join(', '),
    render: (_) => (
      <Paragraph
        ellipsis={{ rows: 4, expandable: "collapsible" }}
        copyable={_?.length ? { tooltips: false } : false}
      >
        {_?.join(", ")}
      </Paragraph>
    )
  },
  enrollments: {
    key: "enrollments",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Enrollments",
        sorter: true,
        icon: alertsColumnIconMap["enrollments"],
        stateData: state,
        key: "enrollments"
      }),
    render: (_) => serviceMap[_],
    dataIndex: "enrollments",
    minWidth: 150
  },
  visa_arn_code_date: {
    key: "visa_arn_code_date",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "ARN Added Date",
        //sorter: true,
        icon: alertsColumnIconMap["visa_arn_code_date"],
        stateData: state,
        key: "visa_arn_code_date"
      }),
    dataIndex: "visa_arn_code_date",
    width: 185,
    render: (_) =>
      _ ? (
        <Space direction="vertical" size={4}>
          <Text>{dayjs(_).format(dateFormat)}</Text>
          <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
        </Space>
      ) : (
        "—"
      )
  },
  arn_codes: {
    key: "arn_codes",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "ARN codes",
        //sorter: true,
        icon: alertsColumnIconMap["arn_codes"],
        stateData: state,
        key: "arn_codes"
      }),
    dataIndex: "arn_codes",
    width: 260,
    //render: (_) => _?.join(', ') || '—',
    //render: (_) => _.map(code => <Paragraph copyable={{tooltips: false}}>{code}</Paragraph>)
    render: (_) => {
      if (_?.length) {
        return (
          <Paragraph
            ellipsis={{ rows: 4, expandable: "collapsible" }}
            copyable={{ tooltips: false }}
          >
            {_?.join(", ")}
          </Paragraph>
        )
      } else {
        return "—"
      }
    }
  },
  bin_codes: {
    key: "bin_codes",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "BIN codes",
        //sorter: true,
        icon: alertsColumnIconMap["bin_codes"],
        stateData: state,
        key: "bin_codes"
      }),
    dataIndex: "bin_codes",
    minWidth: 240,
    render: (_) => {
      if (_?.length) {
        return (
          <Paragraph
            ellipsis={{ rows: 4, expandable: "collapsible" }}
            copyable={{ tooltips: false }}
          >
            {_?.join(", ")}
          </Paragraph>
        )
      } else {
        return "—"
      }
    }
  },
  caid_codes: {
    key: "caid_codes",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "CAID codes",
        //sorter: true,
        icon: alertsColumnIconMap["caid_codes"],
        stateData: state,
        key: "caid_codes"
      }),
    dataIndex: "caid_codes",
    minWidth: 240,
    render: (_) => {
      if (_?.length) {
        return (
          <Paragraph
            ellipsis={{ rows: 4, expandable: "collapsible" }}
            copyable={{ tooltips: false }}
          >
            {_?.join(", ")}
          </Paragraph>
        )
      } else {
        return "—"
      }
    }
  },
  balance_current: {
    key: "balance_current",
    title: (state) =>
      titleSortFilters({
        title: "Current Balance",
        icon: alertsColumnIconMap["balance_current"],
        stateData: state,
        key: "balance_current",
        tooltip: "The balance is shared across all business accounts"
      }),
    dataIndex: "balance_current",
    width: 180,
    render: (_, record) => (
      <ButtonComponent
        type="link"
        shape="circle"
        disabled={!record?.user_id}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onSelectRow(record, "user_balance")
        }}
        className="flex center"
      >
        {_ >= 0 ? "$" + formatNumber(_, 2, ",") : "-$" + formatNumber(Math.abs(_), 2, ",")}
      </ButtonComponent>
    )
  },
  is_use_another_solutions: {
    key: "is_use_another_solutions",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "Using Competitor",
        //sorter: true,
        icon: alertsColumnIconMap["is_use_another_solutions"],
        stateData: state,
        key: "is_use_another_solutions"
      }),
    dataIndex: "is_use_another_solutions",
    minWidth: 180,
    render: (_) => (_ ? "Yes" : "No")
  },
  another_solution_name: {
    key: "another_solution_name",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "Previous solution",
        //sorter: true,
        icon: alertsColumnIconMap["another_solution_name"],
        stateData: state,
        key: "another_solution_name"
      }),
    dataIndex: "another_solution_name",
    minWidth: 180,
    render: (_, record) => (record.is_use_another_solutions ? _ : "—")
  },
  previously_connected_enrollments: {
    key: "previously_connected_enrollments",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "Previously enrolled",
        //sorter: true,
        icon: alertsColumnIconMap["previously_connected_enrollments"],
        stateData: state,
        key: "previously_connected_enrollments"
      }),
    dataIndex: "previously_connected_enrollments",
    minWidth: 185,
    render: (_, record) =>
      _?.map((el) => previouslyConnectedEnrollmentsMap?.[el] || el)?.join(", ") || "—"
  },
  is_user_notified_previous_solution: {
    key: "is_user_notified_previous_solution",
    sorter: false,
    title: (state) =>
      titleSortFilters({
        title: "Previous partner notified",
        //sorter: true,
        icon: alertsColumnIconMap["is_user_notified_previous_solution"],
        stateData: state,
        key: "is_user_notified_previous_solution"
      }),
    dataIndex: "is_user_notified_previous_solution",
    minWidth: 215,
    render: (_, record) => (record.is_use_another_solutions ? (_ ? "Yes" : "No") : "—")
  },
  created_timestamp: {
    key: "created_timestamp",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Request date",
        sorter: true,
        icon: alertsColumnIconMap["created_timestamp"],
        stateData: state,
        key: "created_timestamp"
      }),
    dataIndex: "created_timestamp",
    minWidth: 185,
    render: (_) => (
      <Space direction="vertical" size={4}>
        <Text>{dayjs(_).format(dateFormat)}</Text>
        <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
      </Space>
    )
  },
  updated_timestamp: {
    key: "updated_timestamp",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Update status date",
        sorter: true,
        icon: alertsColumnIconMap["updated_timestamp"],
        stateData: state,
        key: "updated_timestamp"
      }),
    dataIndex: "updated_timestamp",
    minWidth: 200,
    render: (_) =>
      _ ? (
        <Space direction="vertical" size={4}>
          <Text>{dayjs(_).format(dateFormat)}</Text>
          <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
        </Space>
      ) : (
        "—"
      )
  }
  /*enable_auto_refunds: {
      key: 'enable_auto_refunds',
      title: (state) =>
        titleSortFilters({
          title: 'Auto-refund Ethoca&CDRN',
          icon: alertsColumnIconMap['enable_auto_refunds'],
          stateData: state,
          key: 'enable_auto_refunds',
        }),
      dataIndex: 'enable_auto_refunds',
      render: (_) => _ ? 'Yes' : 'No'
    },
    auto_refund_amount_other: {
      key: 'auto_refund_amount_other',
      title: (state) =>
        titleSortFilters({
          title: 'Auto-refund amount Ethoca&CDRN',
          icon: alertsColumnIconMap['auto_refund_amount_other'],
          stateData: state,
          key: 'auto_refund_amount_other',
        }),
      dataIndex: 'auto_refund_amount_other',
      render: (_, record) => record?.['enable_auto_refunds'] ? ('$' + formatNumber(_, 2, ',')) : '—'
    },
    auto_refund_amount_rdr: {
      key: 'auto_refund_amount_rdr',
      title: (state) =>
        titleSortFilters({
          title: 'Auto-refund amount RDR',
          icon: alertsColumnIconMap['auto_refund_amount_rdr'],
          stateData: state,
          key: 'auto_refund_amount_rdr',
        }),
      dataIndex: 'auto_refund_amount_rdr',
      render: (_) => ('$' + formatNumber(_, 2, ','))
    },*/
})

export const getDefaultColumn = ({ field_id, label }) => ({
  key: field_id,
  sorter: true,
  title: (state) =>
    titleSortFilters({
      title: label,
      sorter: true,
      icon: alertsColumnIconMap[field_id],
      stateData: state,
      key: field_id
    }),
  dataIndex: field_id,
  ellipsis: true
})

export const getActionColumn = ({ onSelectRow }) => ({
  key: "actions",
  title: (state) =>
    titleSortFilters({
      title: "Actions",
      sorter: false,
      //icon: 'delete',
      stateData: state,
      key: "delete"
    }),
  //align: 'right',
  width: 136,
  render: (_, record) => {
    const handleAction = (e, data, type) => {
      e.preventDefault()
      e.stopPropagation()
      onSelectRow(data, type)
    }
    return (
      <Flex gap={4}>
        <Tooltip title={record?.["admin_screenshots"]?.length ? "Edit comments" : "Add comments"}>
          <ButtonComponent
            type="link"
            shape="circle"
            icon={<Icon type={record?.["admin_screenshots"]?.length ? "edit_small" : "camera"} />}
            onClick={(e) => handleAction(e, record, "add_comment")}
            className="flex center"
          />
        </Tooltip>
        {record?.["request_status"] && (
          <Tooltip title={record?.["is_archived"] ? "Unarchive" : "Archive"}>
            <ButtonComponent
              type="link"
              shape="circle"
              icon={<Icon type={record?.["is_archived"] ? "unarchive" : "archive"} />}
              onClick={(e) => handleAction(e, record, "archive")}
              className="flex center"
            />
          </Tooltip>
        )}

        <Tooltip title="Delete">
          <ButtonComponent
            danger
            type="link"
            shape="circle"
            icon={<Icon type="delete" />}
            onClick={(e) => handleAction(e, record, "delete")}
            className="flex center table-action-btn"
          />
        </Tooltip>
      </Flex>
    )
  }
})
